package org.ssoft.common.tools

import tk.mallumo.crypto.*


object Crypto {
    private val key = "eatharsyj874ras8e4h175i8".encodeToByteArray()
    private val iv = ByteArray(16) {
        it.toByte()
    }

    fun encrypt(msg: ByteArray): ByteArray {
        return AES.encryptAesCbc(msg, key, iv, Padding.ZeroPadding)
    }

    @Suppress("unused")
    fun decrypt(data: ByteArray): ByteArray {
        return AES.decryptAesCbc(data, key, iv, Padding.ZeroPadding)
    }

}
